<template>
  <VBlock id="payment-method-wrapper">
    <VBlock id="baemin-pay-layout">
      <VBlock id="baemin-pay-container" />
    </VBlock>
  </VBlock>
</template>

<script>
import VBlock from '../../molecules/VBlock'

import BaeminPay from 'baeminpay-front'
import { StoreProps, PaymentMethodSelectionFlowProps } from '@/models/PreOrder/BaeminPaymentMethod'

export default {
  name: 'PaymentMethodLayer',
  components: {
    VBlock
  },
  props: {
    paymentMethod: Object,
    paymentMethodOptions: Array,
    onPaymentMethod: Function
  },
  computed: {
    appVersion() {
      return this.$store.getters.appVersion
    }
  },
  created() {
    const { appVersion } = this.$store.getters
    this.beforeNativeEvent = window.onClickNativeBack
    this.$store.commit('hideNavigationBar', { appVersion })
  },
  mounted() {
    const { baeminMemberNo, isSign, appVersion, isAndroid } = this.$store.getters

    const storeProps = new StoreProps({
      memberNumber: baeminMemberNo,
      externals: {
        deeplink: process.env.VUE_APP_DEEP_LINK_PROTOCOL,
        action: process.env.VUE_APP_BAEMIN_ACTION_DEEP_LINK_PROTOCOL,
        INTERNAL_WEB: process.env.VUE_APP_BAEMIN_INTERNAL_WEB
      },
      logData: {
        env: process.env.NODE_ENV,
        sessionId: this.$store.getters.sessionId,
        dvcId: this.$store.getters.deviceId,
        screenName: 'Ord/Method'
      },
      setAndroidBackHandler: onClose => {
        window.onClickNativeBack = onClose
      }
    })

    const pocketNo = !this.paymentMethod.baeminpay ? null : this.paymentMethod.baeminpay.pocketNo
    const appVersionDeviceTypePrefix = isAndroid ? 'and1_' : 'iph1_'

    const paymentMethodProps = new PaymentMethodSelectionFlowProps({
      selectedCode: this.paymentMethod.code,
      paymentMethodList: this.paymentMethodOptions,
      selectedBaeminpayPocketNo: pocketNo,
      appVersion: appVersionDeviceTypePrefix + appVersion,
      guest: !isSign,
      onSelect: method => {
        this.onPaymentMethod({
          ...method,
          codeName: this.paymentMethodOptions.find(
            option => option.displayName === method.displayName
          ).codeName
        })

        this.$store.dispatch('preOrder/closePaymentMethod')

        const element = document.getElementById('baeminpay-modal-container')
        BaeminPay.ReactDomUnmount(element)
        element.remove()

        window.onClickNativeBack = this.beforeNativeEvent
      },
      onCancel: method => {
        // console.log(this.paymentMethodOptions)
        // console.log(method)

        if (!!method) {
          this.onPaymentMethod({
            ...method,
            codeName: this.paymentMethodOptions.find(
              option => option.displayName === method.displayName
            ).codeName
          })
        }

        this.$store.dispatch('preOrder/closePaymentMethod')

        const element = document.getElementById('baeminpay-modal-container')
        BaeminPay.ReactDomUnmount(element)
        element.remove()

        window.onClickNativeBack = this.beforeNativeEvent
      }
    })

    BaeminPay.renderPaymentMethodSelectionFlow('baemin-pay-container', {
      ...storeProps,
      ...paymentMethodProps
    })
  },
  destroyed() {
    const { appVersion } = this.$store.getters
    this.$store.commit('showNavigationBar', { appVersion })
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/modules/colors';

#payment-method-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  background-color: $background-white;
  display: block;
  z-index: 100;

  #baemin-pay-layout {
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    margin: 0;
    padding: 0;
  }

  #baemin-pay-container {
    overflow: scroll;

    #baeminpay-front-root-container {
      background-color: $background-white;
    }
  }
}
</style>